import {
  BACK_TO_IDENTIFIER_FORM,
  ENTER_TEMPORARY_PASSWORD,
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  RESET_ALL_AUTH_ERROR_MESSAGES,
  RESET_AUTH_ERROR_MESSAGE,
  RESET_PASSWORD_SUCCESS,
  SHOW_AUTH_VALIDATION_ERROR_MESSAGE,
  SHOW_MESSAGE,
  SHOW_TERMS_AND_CONDITIONS,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  VERIFY_USER_SUCCESS,
  VERIFY_USER_SIGNUP_SUCCESS,
  DROP_SESSION,
} from '../constants/ActionTypes';
import { AUTH_TOKEN_KEY } from '../constants/Values';
import { getCookie } from '../util/cookies';

const INIT_STATE = {
  accessToken: getCookie(AUTH_TOKEN_KEY),
  version: '',
  alertMessage: '',
  enterTemporaryPassword: false,
  initURL: '',
  loader: false,
  registered: false,
  resetPasswordStatus: null,
  showMessage: false,
  showTermsAndConditions: false,
  signedIn: !!getCookie(AUTH_TOKEN_KEY),
  signUpConfirmed: false,
  signUpVerified: false,
  termsAndConditionsText: '',
  validationErrors: {
    identifier: null,
    identifierPassword: null,
    newPassword: null,
    temporaryPassword: null,
    verificationCode: null,
  },
  verified: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_ALL_AUTH_ERROR_MESSAGES:
      return {
        ...state,
        validationErrors: {
          identifier: null,
          identifierPassword: null,
          newPassword: null,
          temporaryPassword: null,
          verificationCode: null,
        },
      };
    case RESET_AUTH_ERROR_MESSAGE:
      return {
        ...state,
        validationErrors: {
          ...state.validationErrors,
          [action.payload.messageType]: null,
        },
      };
    case SHOW_AUTH_VALIDATION_ERROR_MESSAGE:
      return {
        ...state,
        loader: false,
        validationErrors: {
          identifier: null,
          identifierPassword: null,
          newPassword: null,
          temporaryPassword: null,
          verificationCode: null,
          [action.payload.type]: action.payload.message,
        },
      };
    case ENTER_TEMPORARY_PASSWORD: {
      return {
        ...state,
        accessToken: action.payload.accessToken,
        enterTemporaryPassword: true,
        loader: false,
        showTermsAndConditions: false,
        registered: true,
        signUpConfirmed: true,
        signUpVerified: true,
      };
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        accessToken: action.payload.accessToken,
        enterTemporaryPassword: false,
        loader: false,
        showTermsAndConditions: false,
        signedIn: true,
      };
    }
    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case SHOW_TERMS_AND_CONDITIONS: {
      return {
        ...state,
        accessToken: action.payload.accessToken,
        version: action.payload.version,
        loader: false,
        registered: true,
        showTermsAndConditions: true,
        signUpConfirmed: true,
        signUpVerified: true,
        termsAndConditionsText: action.payload.termsAndConditionsText,
      };
    }
    case VERIFY_USER_SUCCESS: {
      return {
        ...state,
        verified: true,
        registered: action.payload,
        loader: false,
      };
    }
    case RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        resetPasswordStatus: action.payload.status,
      };
    }
    case VERIFY_USER_SIGNUP_SUCCESS: {
      return {
        ...state,
        loader: false,
        signUpVerified: true,
      };
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload,
      };
    }
    case BACK_TO_IDENTIFIER_FORM:
    case DROP_SESSION:
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        ...INIT_STATE,
        accessToken: undefined,
        signedIn: false,
      };
    }

    case SHOW_MESSAGE: {
      if (action.payload.length > 1) {
        const errorString = action.payload.join('\r \n');
        return {
          ...state,
          alertMessage: errorString,
          showMessage: true,
          loader: false,
          validationErrors: {
            identifier: null,
            identifierPassword: null,
            newPassword: null,
            temporaryPassword: null,
            verificationCode: null,
          },
        };
      }
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
        validationErrors: {
          identifier: null,
          identifierPassword: null,
          newPassword: null,
          temporaryPassword: null,
          verificationCode: null,
        },
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false,
      };
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }
    default:
      return state;
  }
};
